import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class GeoTypeModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (GeoTypeModel._instance == null) GeoTypeModel._instance = new GeoTypeModel(authManager);
        return GeoTypeModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'geo-sections/geo-types');

        this.entityName = 'geo-sections.GeoType';
        this.privileges = {
            create: [["adminGeotechData"],["manageGeotechData"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"]],
            delete: [["adminGeotechData"],["manageGeotechData"]],
        };

        this.label = 'Geological Type';
        this.setLabel = 'Geological Types';

        this.browser = {
            name: 'default-geo-sections-geotype-browser',
            moduleName: 'default-geo-sections-geotype-browser',
            moduleTitle: 'Geological Types',
            moduleStateSlotName: 'default-geo-sections-geotype-browser',
        };

        this.editor = {
            name: 'default-geo-sections-geotype-editor',
            moduleName: 'default-geo-sections-geotype-editor',
            moduleTitle: 'Geological Type',
            moduleStateSlotName: 'default-geo-sections-geotype-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                description: '(zajistit jedinečnost v rámci Code/Standard/Project)',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'codeStandardDocumentId',
                type: 'CodeStandardDocument',
                persistent: true,
                label: 'Code Standard Document',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'geoSectionId',
                type: 'GeoSection',
                persistent: true,
                label: 'Geo Section',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'gravitationalAccelerationG',
                type: 'float',
                persistent: false,
                unit: 'm/s^2',
                label: 'Gravitational Acceleration G',
                readOnly: true,
            },
            {
                name: 'densityOfWaterRoW',
                type: 'float',
                persistent: false,
                unit: 'kg/m^3',
                readOnly: true,
            },
            {
                name: 'unitWeightOfWaterGamaW',
                type: 'float',
                persistent: false,
                unit: 'kN/m^3',
                readOnly: true,
            },
            {
                name: 'massTypeId',
                type: 'GeoMassType',
                persistent: true,
                label: 'Mass Type',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'effectiveCohesionCef',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'effectiveInternalFrictionAngleFiEf',
                type: 'float',
                persistent: true,
                unit: 'deg',
                label: 'Effective Internal Friction Angle Fi Ef',
                description: 'Effective Internal Friction Angle',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'poissonCoefficientNi',
                type: 'float',
                persistent: true,
                unit: '1',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'overconsolidationRatioOcr',
                type: 'float',
                persistent: true,
                unit: '1',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'bulkUnitWeightGamaCalcMethodId',
                type: 'BulkUnitWeightGamaCalculationMethod',
                persistent: true,
                label: 'Bulk Unit Weight Gama Calc Method',
                inEditor: true,
            },
            {
                name: 'bulkUnitWeightGama',
                type: 'float',
                persistent: true,
                unit: 'kN/m^3',
                label: 'Bulk Unit Weight Gama',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'bulkUnitWeightGamaGiven',
                type: 'float',
                persistent: true,
                unit: 'kN/m^3',
                label: 'Bulk Unit Weight Gama Given',
                description: 'gama,bulk =m*g/V',
                inEditor: true,
            },
            {
                name: 'minBulkUnitWeightGamaMinCalcMethodId',
                type: 'MinBulkUnitWeightGamaMinCalculationMethod',
                persistent: true,
                inEditor: true,
            },
            {
                name: 'minBulkUnitWeightGamaMin',
                type: 'float',
                persistent: true,
                unit: 'kN/m^3',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'minBulkUnitWeightGamaMinGiven',
                type: 'float',
                persistent: true,
                unit: 'kN/m^3',
                inEditor: true,
            },
            {
                name: 'dryUnitWeightGamaDCalcMethodId',
                type: 'DryUnitWeightGamaDCalculationMethod',
                persistent: true,
                label: 'Dry Unit Weight Gama D Calc Method',
                inEditor: true,
            },
            {
                name: 'dryUnitWeightGamaD',
                type: 'float',
                persistent: true,
                unit: 'kN/m^3',
                label: 'Dry Unit Weight Gama D',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'dryUnitWeightGamaDGiven',
                type: 'float',
                persistent: true,
                unit: 'kN/m^3',
                label: 'Dry Unit Weight Gama D Given',
                description: 'Dry Unit Weight',
                inEditor: true,
            },
            {
                name: 'specificGravityGs',
                type: 'float',
                persistent: true,
                unit: '1',
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'unitWeightOfSolidsGamaSCalcMethodId',
                type: 'UnitWeightOfSolidsGamaSCalculationMethod',
                persistent: true,
                label: 'Unit Weight Of Solids Gama S Calc Method',
                inEditor: true,
            },
            {
                name: 'unitWeightOfSolidsGamaS',
                type: 'float',
                persistent: true,
                unit: 'kN/m^3',
                label: 'Unit Weight Of Solids Gama S',
                description: 'Unit Weight of Solids Chosen Value',
                readOnly: true,
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'unitWeightOfSolidsGamaSGiven',
                type: 'float',
                persistent: true,
                unit: 'kN/m^3',
                label: 'Unit Weight Of Solids Gama S Given',
                description: 'Unit Weight of Solids Given',
                inEditor: true,
            },
            {
                name: 'minUnitWeightOfSolidsGamaSMinCalcMethodId',
                type: 'MinUnitWeightOfSolidsGamaSMinCalculationMethod',
                persistent: true,
                label: 'Min Unit Weight Of Solids Gama S Min Calc Method',
                inEditor: true,
            },
            {
                name: 'minUnitWeightOfSolidsGamaSMin',
                type: 'float',
                persistent: true,
                unit: 'kN/m^3',
                label: 'Min Unit Weight Of Solids Gama S Min',
                description: '    min_gama3specific (kN/m³)\n    dry unit weight',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'minUnitWeightOfSolidsGamaSMinGiven',
                type: 'float',
                persistent: true,
                unit: 'kN/m^3',
                label: 'Min Unit Weight Of Solids Gama S Min Given',
                description: 'Min Unit Weight of Solids Given',
                inEditor: true,
            },
            {
                name: 'saturatedUnitWeightGamaSatCalcMethodId',
                type: 'SaturatedUnitWeightGamaSatCalculationMethod',
                persistent: true,
                label: 'Saturated Unit Weight Gama Sat Calc Method',
                inEditor: true,
            },
            {
                name: 'saturatedUnitWeightGamaSat',
                type: 'float',
                persistent: true,
                unit: 'kN/m^3',
                label: 'Saturated Unit Weight Gama Sat',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'saturatedUnitWeightGamaSatGiven',
                type: 'float',
                persistent: true,
                unit: 'kN/m^3',
                label: 'Saturated Unit Weight Gama Sat Given',
                inEditor: true,
            },
            {
                name: 'submergedUnitWeightGamaSubCalcMethodId',
                type: 'SubmergedUnitWeightGamaSubCalculationMethod',
                persistent: true,
                label: 'Submerged Unit Weight Gama Sub Calc Method',
                inEditor: true,
            },
            {
                name: 'submergedUnitWeightGamaSub',
                type: 'float',
                persistent: true,
                unit: 'kN/m^3',
                label: 'Submerged Unit Weight Gama Sub',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'submergedUnitWeightGamaSubGiven',
                type: 'float',
                persistent: true,
                unit: 'kN/m^3',
                label: 'Submerged Unit Weight Gama Sub Given',
                inEditor: true,
            },
            {
                name: 'minSubmergedUnitWeightGamaSubMinCalcMethodId',
                type: 'MinSubmergedUnitWeightGamaSubMinCalculationMethod',
                persistent: true,
                inEditor: true,
            },
            {
                name: 'minSubmergedUnitWeightGamaSubMin',
                type: 'float',
                persistent: true,
                unit: 'kN/m^3',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'minSubmergedUnitWeightGamaSubMinGiven',
                type: 'float',
                persistent: true,
                unit: 'kN/m^3',
                inEditor: true,
            },
            {
                name: 'hasBuoyancyEffectWhenUnderWater',
                type: 'bool',
                persistent: true,
                label: 'Has Buoyancy Effect When Under Water',
                description: '(Except Capillary Water)',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'degreeOfSaturationSrCalcMethodId',
                type: 'DegreeOfSaturationSrCalculationMethod',
                persistent: true,
                label: 'Degree Of Saturation Sr Calc Method',
                inEditor: true,
            },
            {
                name: 'degreeOfSaturationSr',
                type: 'float',
                persistent: true,
                unit: '1',
                label: 'Degree Of Saturation Sr',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'degreeOfSaturationSrGiven',
                type: 'float',
                persistent: true,
                unit: '1',
                label: 'Degree Of Saturation Sr Given',
                inEditor: true,
            },
            {
                name: 'moistureContentWCalcMethodId',
                type: 'MoistureContentWCalculationMethod',
                persistent: true,
                label: 'Moisture Content W Calc Method',
                inEditor: true,
            },
            {
                name: 'moistureContentW',
                type: 'float',
                persistent: true,
                unit: '%',
                label: 'Moisture Content W',
                description: 'Moisture (Water) Content Chosen Value',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'moistureContentWGiven',
                type: 'float',
                persistent: true,
                unit: '%',
                label: 'Moisture Content W Given',
                description: '    for info - basic equation:\n    = m,w / m,s * 100%',
                inEditor: true,
            },
            {
                name: 'plasticityIndexIpCalcMethodId',
                type: 'PlasticityIndexIpCalculationMethod',
                persistent: true,
                label: 'Plasticity Index Ip Calc Method',
                inEditor: true,
            },
            {
                name: 'plasticityIndexIp',
                type: 'float',
                persistent: true,
                unit: '%',
                label: 'Plasticity Index Ip',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'plasticityIndexIpGiven',
                type: 'float',
                persistent: true,
                unit: '%',
                label: 'Plasticity Index Ip Given',
                description: '=LL-PL',
                inEditor: true,
            },
            {
                name: 'porosityNCalcMethodId',
                type: 'PorosityNCalculationMethod',
                persistent: true,
                label: 'Porosity N Calc Method',
                inEditor: true,
            },
            {
                name: 'porosityN',
                type: 'float',
                persistent: true,
                unit: '%',
                label: 'Porosity N',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'porosityNGiven',
                type: 'float',
                persistent: true,
                unit: '%',
                label: 'Porosity N Given',
                inEditor: true,
            },
            {
                name: 'voidRatioECalcMethodId',
                type: 'VoidRatioECalculationMethod',
                persistent: true,
                label: 'Void Ratio E Calc Method',
                inEditor: true,
            },
            {
                name: 'voidRatioE',
                type: 'float',
                persistent: true,
                unit: '1',
                label: 'Void Ratio E',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'voidRatioEGiven',
                type: 'float',
                persistent: true,
                unit: '1',
                label: 'Void Ratio E Given',
                description: 'Void Ratio',
                inEditor: true,
            },
            {
                name: 'effectiveGrainSizeD10',
                type: 'float',
                persistent: true,
                unit: 'mm',
                inEditor: true,
            },
            {
                name: 'grainSizeD30',
                type: 'float',
                persistent: true,
                unit: 'mm',
                inEditor: true,
            },
            {
                name: 'grainSizeD60',
                type: 'float',
                persistent: true,
                unit: 'mm',
                inEditor: true,
            },
            {
                name: 'k0CalcMethodId',
                type: 'K0CalculationMethod',
                persistent: true,
                label: 'K 0 Calc Method',
                description: '(coefficient of lateral earth pressure at rest)',
                inEditor: true,
            },
            {
                name: 'coefficientOfLateralEarthPressureAtRestK0',
                type: 'float',
                persistent: true,
                unit: '1',
                label: 'Coefficient Of Lateral Earth Pressure At Rest K 0',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
        ];

    }

}
